
<template>
  <div class="TodaySales">
    <h1>TodaySales</h1>
    <p>This is the TodaySales component.</p>
    <p>Default data: {{ defaultData }}</p>
  </div>
</template>

<script>
export default {
  name: 'TodaySales',
  data() {
    return {
      defaultData: 'Default data for TodaySales'
    };
  }
};
</script>

<style scoped>
.TodaySales {
  padding: 20px;
}
</style>
